import { computed, Injectable, signal } from '@angular/core';
import { langRessources } from '@lang';

enum Lang { EN = 'en', ES = 'es' }

@Injectable({
  providedIn: 'root'
})

export class TextService {
  defaultLanguage = Lang.EN
  language = signal<string>((navigator.language in Lang) ? navigator.language : this.defaultLanguage)
  getText = computed(() => langRessources.filter( (ressource: any) => ressource.language === this.language())[0]['text'])


  public setLanguage(language: string): void {
    this.language.set(language)
  }

  get DropDownLanguage(): InputOption[] {
    return [
      {
        text: 'English',
        value: Lang.EN,
        selected: this.language() == Lang.EN
      },
      {
        text: 'Spanish',
        value: Lang.ES,
        selected: this.language() == Lang.ES
      }
    ]
  }
  
}
